import { getUtmParamsFromSearch, hasUtmParams, saveUtmToSession } from "../utm-params";

/**
 * ページ読み込み時に URL の UTM を sessionStorage に保存する。
 * サインアップ・セットアップ完了時に HubSpot へ渡してトラッキングするために使用する。
 */
export const captureUtmOnLoad = (): void => {
	if (typeof window === "undefined") return;
	const utm = getUtmParamsFromSearch(window.location.search);

	if (!hasUtmParams(utm)) return;

	saveUtmToSession(utm);
};
